(function (Drupal, $) {
  Drupal.behaviors.stickyTabs = {
    attach: function (context) {
      $(function () {
        if ($("#in-page-nav-wrapper").length) {
          var diff = $("#in-page-nav-wrapper").outerHeight();
        } else {
          var diff = $("#global-header").outerHeight();
        }

        $(".paragraph-sticky-tabs__content")
          .once()
          .each(function () {
            $(".paragraph-sticky-tabs__tab-desktop").on("click", function () {
              var $this = $(this);
              var index = $this.index();

              $this.addClass("active").siblings().removeClass("active");
              var target = $this
                .parent()
                .siblings(".paragraph-sticky-tabs__items")
                .children('.paragraph-sticky-tabs__item:eq("' + index + '")');

              $("html, body")
                .stop()
                .animate({
                  scrollTop: target.offset().top - 16 - diff,
                });
            });
          });

        //Adjusting active item on scroll
        if (
          $(".paragraph-sticky-tabs__content").length &&
          window.matchMedia("(min-width: 1200px)").matches
        ) {
          $(window).on("scroll", function () {
            $(".paragraph-sticky-tabs__item").each(function () {
              var $this = $(this);
              var index = $this.index();

              if (
                $this[0].getBoundingClientRect().y +
                  $this.outerHeight() -
                  diff >
                0
              ) {
                var target = $this
                  .parent()
                  .siblings(".paragraph-sticky-tabs__tabs-desktop")
                  .children(
                    '.paragraph-sticky-tabs__tab-desktop:eq("' + index + '")'
                  );

                target.addClass("active").siblings().removeClass("active");

                return false;
              }
            });
          });
        }
      });
    },
  };
})(Drupal, jQuery);
